module.exports = require("crypto");


/*****************
 ** WEBPACK FOOTER
 ** external "crypto"
 ** module id = 16
 ** module chunks = 0
 **/